module.exports = __webpack_public_path__ + "static/sport/bgi-dialog.27cccc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/euro/bgi-dialog.png
// module id = 8/64
// module chunks = 0